import { FC, useState } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';
import { useProtocolTypeData } from './hooks/useProtocolTypeData';
import { ProtocolType, ProtocolTypeSummary } from '../../types';
import usePaginatedDonutChart from '../../hooks/usePaginatedDonutChart';

interface ProtocolTypeChartProps {
    protocolTypeSummary?: ProtocolTypeSummary;
    isLoading: boolean;
    className?: string;
    onClick: (protocolType: ProtocolType) => void;
    innerCircleEmptyStateClassName?: string;
}

enum DropdownOption {
    MFA = 'mfa',
    ALL = 'all'
}

const ProtocolTypeChart: FC<ProtocolTypeChartProps> = ({ protocolTypeSummary, isLoading, className, onClick, innerCircleEmptyStateClassName = '' }) => {
    const [selectedDropdownOption, setSelectedDropdownOption] = useState<DropdownOption>(DropdownOption.MFA);
    const relevantProtocolTypeSummary =
        selectedDropdownOption === DropdownOption.MFA ? protocolTypeSummary?.mfa : protocolTypeSummary?.all;
    const chartData = useProtocolTypeData(onClick, relevantProtocolTypeSummary);
    const pages = usePaginatedDonutChart({ chartData, isLoading, innerCircleEmptyStateClassName });

    return (
        <LayoutCarousel
            title="Protocol type"
            className={className}
            contentClassName="flex flex-1 flex-col justify-center px-6 flex-shrink-0"
            pages={pages}
            dropDownProps={{
                variant: 'trigger',
                items: [
                    { value: DropdownOption.MFA, title: 'MFA authentications' },
                    { value: DropdownOption.ALL, title: 'All authentications' }
                ],
                size: 'large',
                width: '160px',
                className: '[&]:w-[160px] border [&]:border-sf-gray-100 bg-transparent',
                selectedItems: selectedDropdownOption,
                onChange: (value) => setSelectedDropdownOption(value as DropdownOption)
            }}
        />
    );
};

export default ProtocolTypeChart;
